import StringHelpers from "helpers/StringHelpers";

/**
 * @see https://mui.com/material-ui/react-autocomplete/#createfilteroptions-config-filteroptions
 */
export const exerciseAutocompleteFilterOptions = (options, state) => {
  const result = options.filter((option) => {
    const stringifiedOption = StringHelpers.removeDiacritics(
      [option.name, option.category, option.type, ...(option.searchTerms || [])].filter(Boolean).join(" ").toLowerCase()
    );
    const splitInputValue = StringHelpers.removeDiacritics(state.inputValue.toLowerCase()).split(" ");
    return splitInputValue.every((inputValue) => stringifiedOption.includes(inputValue));
  });
  return result;
};

/**
 * @see https://mui.com/material-ui/react-autocomplete/#createfilteroptions-config-filteroptions
 */
export const metadataAutocompleteFilterOptions = (options, state) => {
  const result = options.filter((option) => {
    const stringifiedOption = StringHelpers.removeDiacritics(
      [
        option?.metadata?.name,
        option?.metadata?.label,
        option?.metadata?.category,
        option?.type,
        option?.metadata?.label,
        ...(option?.metadata?.searchTerms || []),
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase()
    );
    // eslint-disable-next-line no-undef
    const splitInputValue = StringHelpers.removeDiacritics(state.inputValue.toLowerCase()).split(" ");
    return splitInputValue.every((inputValue) => stringifiedOption.includes(inputValue));
  });
  return result;
};
